import React, { Component } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history'
import Header from './components/Header';
import Container from './components/Container';
import strings from './utils/Localization';
import './assets/css/styles.css';
import { StateProvider } from './context/state';

const history = createBrowserHistory();
const lang = strings.getInterfaceLanguage().substring(0, 2);
strings.setLanguage(lang);

export default class App extends Component {
  render() {
    return (
        <StateProvider>
          <Router history={history}>
            <div className="app">
              <Header />
              <Container />
            </div>
          </Router>
        </StateProvider>
    );
  }
}
